
import Orientation from 'react-native-orientation';
import { View, Text, StyleSheet, ScrollView, TouchableOpacity, StatusBar, Dimensions } from 'react-native';
import React, { Component } from 'react';
import { Image } from 'react-native';
import Colors from './Colors'
import { RNCamera } from 'react-native-camera';
import Icon from 'react-native-vector-icons/FontAwesome';
import moment from 'react-moment'
import Geolocation from '@react-native-community/geolocation';
const leftFlex = 0.85
const rightFlex = 0.15
const crossMark = require('./Image/crossMark.png')
const startRecording = require('./Image/startRecording.png')
const stopRecording = require('./Image/stopRecording.png')
const tickMark = require('./Image/tickMark.png')
const topLeft = require('./Image/topLeft.png')
const topRight = require('./Image/topRight.png')
const leftBottom = require('./Image/leftBottom.png')
const rightBottom = require('./Image/rightBottom.png')
const flashIcon = require('./Image/flash.png')
let SCREEN_WIDTH;
let SCREEN_HEIGHT;
const FLASH_LIGHT = [RNCamera.Constants.FlashMode.off, RNCamera.Constants.FlashMode.auto, RNCamera.Constants.FlashMode.on, RNCamera.Constants.FlashMode.torch]
let FLASH_INDEX = 0
export default class VideoRecorder extends Component {
    constructor(props) {
        super(props);
        this.state = ({
            isDisplayQuoteInstruction: true,
            isWithQuote: true,
            isWithOutQuote: false,
            isDisplayInstruction: false,
            torchon: '',
            isDisplayCameraPreview: false,
            isDisplayCamera: false,
            localPath: '',
            flashState: RNCamera.Constants.FlashMode.off,//for flash
            dateAndTime: '',//date and time
            currentLongitude: 'unknown',//Initial Longitude
            currentLatitude: 'unknown',//Initial Latitude
            isDisplayVideoRecorder: false,
            fullDataSource: '',
            assets: '',
            headerShown: false,
            count: 0,
            dataSource: '',
            cameraState: '',
            buttonText: '',
            skipdata: '',
            isBackButtonPressed: false,
            isSkipButtonPressed: false,
            screenShotPath: '',
            isDisplayUploadDocument: false,
            upLoadIamgeDataSource: [],
            documentUploadPercentage: 0,
            odometerReading: '',
            ANDROID_ID: '',
            CurrentDate: '',
            showError: false,
            isLoading: true,
            registrationNumber: '',
            isSelected: false,
            isFocused: false,
            staincil: this.props.navigation.state.params.staincil,
            count: this.props.navigation.state.params.count,
            productImage: this.props.navigation.state.params.productImage,
            extention: this.props.navigation.state.params.extention,
            stepTitle: this.props.navigation.state.params.stepTitle,
            instructionData: this.props.navigation.state.params.instructionData,


        })

    }

    /*
                              %%%%%%%%%%%%% For Video Record %%%%%%%%%%%%%%%%
   */

    async startRecording() {
        this.setState({ recording: true });
        // default to mp4 for android as codec is not set
        const options = { quality: 0.2, base64: true };
        const { uri, codec = "mp4" } = await this.camera.recordAsync(options);
        this.setState({ localPath: uri })
        setTimeout(() => {
            this.props.navigation.navigate("VideoPreview",
                {
                    localPath: this.state.localPath,
                    finalWatermarkResult: this.state.finalWatermarkResult,
                    count: this.state.count,
                    productImage: this.state.productImage,
                    stepTitle: this.state.stepTitle,
                    extention: this.state.extention,
                    instructionData: this.state.instructionData
                })
        }, 500);

    }

    //Stop Recording
    stopRecording() {
        this.camera.stopRecording();
        this.setState({ flashState: RNCamera.Constants.FlashMode.off });
        this.setState({ recording: false, });
    }

    componentDidMount() {
        // this locks the view to Portrait Mode
        const initial = Orientation.getInitialOrientation();
        Orientation.addOrientationListener(this._orientationDidChange)
        Orientation.lockToLandscapeLeft()

        if (initial === 'PORTRAIT') {
            // do something
            SCREEN_HEIGHT = Math.round(Dimensions.get('window').height)
            SCREEN_WIDTH = Math.round(Dimensions.get('window').width)
        } else {
            // do something else
            SCREEN_HEIGHT = Math.round(Dimensions.get('window').height)
            SCREEN_WIDTH = Math.round(Dimensions.get('window').width)
        }
    }

    _orientationDidChange = (orientation) => {
        if (orientation === 'LANDSCAPE') {
            // do something with landscape layoutr
            SCREEN_HEIGHT = Math.round(Dimensions.get('window').height)
            SCREEN_WIDTH = Math.round(Dimensions.get('window').width)

        } else {
            // do something with portrait layout   
            SCREEN_HEIGHT = Math.round(Dimensions.get('window').width)
            SCREEN_WIDTH = Math.round(Dimensions.get('window').height)
        }
    }
    componentWillUnmount() {
        Orientation.removeOrientationListener(this._orientationDidChange)
    }
    render() {
        Orientation.lockToLandscapeLeft()

        SCREEN_HEIGHT = Math.round(Dimensions.get('window').height)
        SCREEN_WIDTH = Math.round(Dimensions.get('window').width)

        const { recording, processing } = this.state;

        let button = (
            <View style={{ flex: 1, flexDirection: 'column' }}>
                <View style={{ flex: 0.7 }}>
                    <TouchableOpacity onPress={() => [this.startRecording()]} style={styles.capture}>
                        <Image
                            source={startRecording}
                            style={{ width: 70, height: 70 }}
                        />
                    </TouchableOpacity>
                </View>
                <View style={{ flex: 0.3 }}>
                    <TouchableOpacity onPress={() => this.toggleTorch()} style={styles.capture}>
                        <Image
                            source={flashIcon}
                            style={{ width: 70, height: 70 }}
                        />
                    </TouchableOpacity>
                    <Text style={styles.torchTitle}>{this.getFlashTorch(this.state.flashState)}</Text>
                </View>
            </View>
        );

        if (recording) {
            button = (
                <View style={{ flex: 1, flexDirection: 'column' }}>
                    <View style={{ flex: 0.7 }}>
                        <TouchableOpacity onPress={() => [this.stopRecording()]} style={styles.capture}>
                            <Image
                                source={stopRecording}
                                style={{ width: 70, height: 70 }}
                            />
                        </TouchableOpacity>
                    </View>
                    <View style={{ flex: 0.3 }}>
                        <TouchableOpacity onPress={() => this.toggleTorch()} style={styles.capture}>
                            <Image
                                source={flashIcon}
                                style={{ width: 70, height: 70 }}
                            />
                        </TouchableOpacity>
                        <Text style={styles.torchTitle}>{this.getFlashTorch(this.state.flashState)}</Text>
                    </View>
                </View>

            );
        }
        return (
            <View style={styles.container}>

                <StatusBar
                    hidden={true}
                />
                <View style={{ flex: 1, flexDirection: 'row' }}>
                    <RNCamera
                        ref={ref => {
                            this.camera = ref;
                        }} style={[styles.preview, { flex: leftFlex }]}
                        type={this.state.cameraState}
                        flashMode={this.state.flashState}
                        androidCameraPermissionOptions={{
                            title: 'Permission to use camera',
                            message: 'We need your permission to use your camera',
                            buttonPositive: 'Ok',
                            buttonNegative: 'Cancel',
                        }}
                        androidRecordAudioPermissionOptions={{
                            title: 'Permission to use audio recording',
                            message: 'We need your permission to use your audio',
                            buttonPositive: 'Ok',
                            buttonNegative: 'Cancel',
                        }}
                        // pausePreview={true}
                        // pauseAfterCapture={true}
                        autoFocus={true}
                    >
                    </RNCamera>
                    <View style={{ backgroundColor: Colors.greyBlack, flex: rightFlex }}></View>
                    <View style={{ flex: 1, flexDirection: 'row', position: 'absolute', width: SCREEN_WIDTH, height: SCREEN_HEIGHT }}>
                        <View style={{ flex: leftFlex, flexDirection: 'column' }}>

                            <View style={{ flex: 1, flexDirection: 'row', justifyContent: 'space-between' }}>
                                <Image
                                    source={topLeft}
                                    style={{ width: 70, height: 70, left: 1, resizeMode: 'contain' }}
                                />
                                <Image
                                    source={topRight}
                                    style={{ width: 70, height: 70, right: 1, resizeMode: 'contain' }}
                                />
                            </View>
                            <View style={{ flex: 1, flexDirection: 'row', justifyContent: 'space-between', alignItems: 'flex-end' }}>
                                <Image
                                    source={leftBottom}
                                    style={{ width: 70, height: 70, left: 1, bottom: 1, resizeMode: 'contain' }}
                                />
                                <Image
                                    source={rightBottom}
                                    style={{ width: 70, height: 70, right: 1, bottom: 1, resizeMode: 'contain' }}
                                />
                            </View>
                            {/* {this.getStencilView()} */}
                        </View>
                        <View style={{ flex: rightFlex, flexDirection: 'column' }}>
                            {button}
                        </View>
                    </View>
                    <View style={{ flex: 1, flexDirection: 'row', position: 'absolute', width: SCREEN_WIDTH, height: SCREEN_HEIGHT }}>
                        <View style={{ flex: leftFlex, justifyContent: 'center', alignItems: 'center' }}>
                            {/* {this.getStencilView()} */}
                        </View>
                        <View style={{ flex: rightFlex }}>
                        </View>
                    </View>
                </View>
            </View>
        );
    }

    getStencilView() {
        if (this.state.staincil)
            return (
                <Image
                    source={{ uri: this.state.staincil }}
                    style={{ width: SCREEN_WIDTH - 50, height: SCREEN_HEIGHT, position: 'absolute', marginRight: 15, marginLeft: 15, resizeMode: 'contain' }}
                />
            )
        else
            return null

    }

    toggleTorch() {
        FLASH_INDEX = FLASH_INDEX + 1

        if (FLASH_INDEX == FLASH_LIGHT.length)
            FLASH_INDEX = 0

        this.setState({ flashState: FLASH_LIGHT[FLASH_INDEX] })


    }


    getFlashTorch(activeFlashType) {
        switch (activeFlashType) {
            case RNCamera.Constants.FlashMode.off:
                return "off";
            case RNCamera.Constants.FlashMode.auto:
                return "auto";
            case RNCamera.Constants.FlashMode.on:
                return "on";
            case RNCamera.Constants.FlashMode.torch:
                return "torch";
            default:
                return "off";
        }
    }
}
const styles = StyleSheet.create({
    main: {
        flex: 1,
        flexDirection: 'row'
    },
    productImageView: {
        flex: 0.475,
    },
    blankView: {
        flex: 0.05,
    },
    productInfoView: {
        flex: 0.475,
        marginRight: 16,
        width: SCREEN_WIDTH,
        height: SCREEN_HEIGHT
    },
    headerView: {
        backgroundColor: '#C6AFFF',
        height: 40,
        justifyContent: 'center'
    },
    headerText: {
        marginLeft: 16,
        fontSize: 20,
        fontFamily: 'Muli-Black'
    },
    productImageStyle: {
        marginTop: 8,
        marginLeft: 16,
        marginBottom: 40,
        height: SCREEN_HEIGHT - 70
    },
    backButtonImageStyle: {
        marginLeft: 32,
        height: 24,
        width: 24,
        backgroundColor: 'red'
    },
    subHeaderText: {
        fontFamily: 'Mulli-Regular',
        fontSize: 16,
        marginLeft: 16
    },
    instructionText: {
        fontFamily: 'Mulli-Regular',
        fontSize: 16,
        marginLeft: 16,
        marginBottom: 20
    },
    captureImageButtonView: {
        height: 48,
        borderRadius: 4,
        backgroundColor: Colors.digitYellow,
        marginTop: 2,
        flexDirection: 'row',
        justifyContent: 'center',
    },
    captureImageButtonText: {
        fontSize: 16,
        fontFamily: 'Muli-Black',
        alignSelf: 'center'
    },
    container: {
        flex: 1,
        // flexDirection: 'row',
        // backgroundColor: 'black',
    },
    preview: {
        flex: 1,
        justifyContent: 'flex-end',
        alignItems: 'center',
    },
    capture: {
        flex: leftFlex,
        alignItems: 'center',
        justifyContent: 'flex-end'
    },
    torchTitle: {
        alignSelf: 'center',
        justifyContent: 'center',
        fontFamily: 'Muli-Bold',
        color: Colors.white
    },
    flash: {
        flex: rightFlex,
        alignItems: 'center',
    },
    previewImageStyle: {
        width: SCREEN_WIDTH,
        height: SCREEN_HEIGHT
    },
    dateAndTimeText: {
        position: 'absolute',
        fontSize: 20,
        color: Colors.digitYellow,
        left: 1,
        bottom: 1
    },
    previewImageIconMainView: {
        flex: 0.05,
        backgroundColor: 'black'
    },
    tickMarkImageView: {
        flex: 0.6,
        justifyContent: 'flex-end'
    },
    tickMarkImageStyle: {
        width: 30,
        height: 30,
        backgroundColor: 'white',
        alignContent: 'flex-end',
        marginBottom: 20
    },
    crossImageView: {
        flex: 0.4,
        justifyContent: 'flex-end',
        marginBottom: 20
    },
    crossImageStyle: {
        width: 30,
        height: 30,
        backgroundColor: 'white',
        alignContent: 'flex-end'
    },
    cameraIconView: {
        flexDirection: 'row',
        justifyContent: 'center',
        width: SCREEN_WIDTH,
        position: 'absolute'
    },
    infoScrollView: {
        marginTop: 40,
        height: SCREEN_HEIGHT - 200
    },
    subHeaderTextView: {
        height: 40,
        marginTop: 8
    },
    backButtonImageView: {
        backgroundColor: '#C6AFFF',
        height: 40,
        justifyContent: 'center',
        marginLeft: 16
    },
    latLongText: {
        position: 'absolute',
        fontSize: 20,
        color: Colors.digitYellow,
        left: 1,
    },
    digitEdgeText: {
        position: 'absolute',
        fontSize: 20,
        color: Colors.digitYellow,
        right: 1,
    }


});


